import { setContext, getContext } from 'svelte';
import { writable } from 'svelte/store';
export function initDarkMode(state = false) {
    const darkModeStore = writable(state);
    setContext('DARK_MODE', darkModeStore);
    return darkModeStore;
}
export function getDarkMode() {
    return getContext('DARK_MODE') || writable(false);
}
